import React from 'react';
import PropTypes from 'prop-types';
import { VOTES } from '../../../helpers/constants';
import styled from 'styled-components';

const Status = styled.div`
  color: ${({ color }) => color};
`;
const StatusLabel = styled.span`
  text-transform: uppercase;
`;
const AttachmentLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;

const renderVotedBy = votedBy => {
  if (!votedBy) {
    return null;
  }

  if (typeof votedBy === 'string') {
    return ` (${votedBy})`;
  }

  const { name, mode, verb, attachment } = votedBy;

  if (mode === 'entered' && attachment) {
    return (
      <>
        {' ('}
        <AttachmentLink
          href={attachment.path}
          target="_blank"
          rel="noopener noreferrer"
          download
        >
          {`${verb} ${name}`}
        </AttachmentLink>
        {')'}
      </>
    );
  }

  if (mode === 'certifies') {
    return ` (poświadcza ${name})`;
  }

  return ` (${name} osobiście)`;
};

const VoteLabel = props => {
  const { vote, votedBy } = props;
  const voteProps = Object.values(VOTES).find(item => vote === item.value);

  return (
    <>
      {vote !== 0 && (
        <Status color={voteProps.color} small>
          <StatusLabel>{voteProps.label}</StatusLabel>
          {renderVotedBy(votedBy)}
        </Status>
      )}
    </>
  );
};

VoteLabel.propTypes = {
  vote: PropTypes.number.isRequired,
  votedBy: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      name: PropTypes.string,
      mode: PropTypes.oneOf(['personally', 'certifies', 'entered']),
      verb: PropTypes.string,
      attachment: PropTypes.shape({
        name: PropTypes.string,
        mime_type: PropTypes.string,
        path: PropTypes.string
      })
    })
  ])
};

VoteLabel.defaultProps = {
  votedBy: null
};

export default VoteLabel;
